import faker from 'faker';

import { IHSCodeData } from '../hs-code.types';
import { createRange } from '@/utils/helpers';

export function createRandomHSCode(): IHSCodeData {
  return {
    code: faker.datatype.uuid(),
    description: faker.lorem.paragraphs()
  };
}

export const mockHSCodesData: IHSCodeData[] = createRange(5).map(() =>
  createRandomHSCode()
);
